import format from '../services/format'

export const STANDARD_APPOINTMENT_ACTIVITIES = [
  { type: 'Appointment Prep', time: 0.5, hasScheduledDate: false, description: 'Appointment Prep', sortOrder: 0 },
  { type: 'Travel', time: '', hasScheduledDate: true, description: 'Travel', sortOrder: 1 },
  { type: 'Wait', time: '', hasScheduledDate: true, description: 'Wait time for IW to arrive', sortOrder: 2 },
  { type: 'Wait', time: '', hasScheduledDate: true, description: 'Wait time in lobby', sortOrder: 3 },
  { type: 'Wait', time: '', hasScheduledDate: true, description: 'Wait time in exam room', sortOrder: 4 },
  {
    type: 'Coordination of Services',
    time: '',
    hasScheduledDate: true,
    description: 'Time with provider',
    sortOrder: 5,
  },
  { type: 'Wait', time: '', hasScheduledDate: false, description: 'Wait time for documents', sortOrder: 6 },
  { type: 'Other', time: '', hasScheduledDate: false, description: 'Upload documents', sortOrder: 7 },
  { type: 'Record Review', time: '', hasScheduledDate: false, description: 'Review documents', sortOrder: 8 },
  {
    type: 'Coordination of Services',
    time: 0.2,
    hasScheduledDate: true,
    description: 'Check in / Check out',
    sortOrder: 9,
  },
  {
    type: 'Coordination of Services',
    time: 1.0,
    hasScheduledDate: false,
    description: 'Appointment summary',
    sortOrder: 10,
  },
  {
    type: 'Coordination of Services',
    time: 0.2,
    hasScheduledDate: false,
    description: 'Email to adjuster with appointment summary',
    sortOrder: 11,
  },
]

export const RECORD_REVIEW_RECORD_TYPES = [
  'Review documents',
  'MRI Reading',
  'CT Scan Report',
  'X-Ray Report',
  'EMG / NCV Study',
  'Ultrasound Report',
  'Initial Evaluation / Assessment',
  'Progress Notes / Office Visit Notes',
  'Orthopedic Consultation Report',
  'Neurological Consultation Report',
  'Pain Management Records',
  'Physical Therapy (PT) Notes',
  'Occupational Therapy (OT) Notes',
  'Chiropractic Treatment Notes',
  'Operative Report (Op Note)',
  'Hospital Discharge Summary',
  'Emergency Room (ER) Records',
  'Independent Medical Examination (IME)',
  'Functional Capacity Evaluation (FCE)',
  'Utilization Review (UR) / Peer Review',
  'Maximum Medical Improvement (MMI) / Impairment Rating',
  'Work Status / Disability Certificate (PR-2 / PR-4)',
  'Pharmacy / Medication Profile',
  'Laboratory / Pathology Results',
]

export const buildStandardAppointmentActivities = (scheduledDate, userId) => {
  const formattedDate = scheduledDate ? new Date(format.date(scheduledDate)) : null
  return STANDARD_APPOINTMENT_ACTIVITIES.map((act, index) => ({
    date: act.hasScheduledDate ? formattedDate : null,
    type: act.type,
    time: act.time !== '' ? act.time : '',
    description: act.description,
    userId: userId || '',
    sortOrder: act.sortOrder ?? index,
    clientActivityId: `template-${index}-${Math.random().toString(36).substr(2, 9)}`,
  }))
}
